export default "__VITE_ASSET__Dkf3FahU__"